import React, { useEffect, useRef } from 'react';
import PrpoTypes from 'prop-types';
import LoadingSwoosh from 'assets/svg/LoadingSwoosh.svg';
import styles from './LoadScreen.module.scss';
import matManLoader from 'assets/images/mat-man-loader.png';
import { t } from '../../translations';

const usePrevious = value => {
  const ref = useRef();

  useEffect(() => {
    ref.current = value;
  });

  return ref.current;
};

const LoadScreen = ({ loading, onLoadEnd }) => {
  const prevLoading = usePrevious({ loading });
  const isLoading = loading || prevLoading;

  useEffect(() => {
    if (prevLoading && !loading) {
      setTimeout(onLoadEnd, 500);
    }
  }, [loading]);

  if (!loading) return null;

  return (
    <div className={styles.loaderMain}>
      <div className={styles.matManImg}>
        <div className={styles.loaderWrapper}>
          <img className={styles.img} src={matManLoader} alt={t('MatManLoader')} />
          <div className={styles.spinner}>
            <img src={LoadingSwoosh} className={styles.path} alt={t('LoadingSwoosh')} />
          </div>
        </div>
        <p className={styles.loadText}>{isLoading && 'Loading...'}</p>
      </div>
    </div>
  );
};

LoadScreen.defaultProps = {
  loading: true,
  onLoadEnd: null
};
LoadScreen.propTypes = {
  loading: PrpoTypes.bool,
  onLoadEnd: PrpoTypes.func
};

export default LoadScreen;
